"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./../../SchoolPerformance.module.css"));
function AsherCostProgram(props) {
    var firstYear = 2018;
    var secondYear = 2019;
    var firstCost = "";
    var secondCost = "";
    var years = props.programData["years"] ? props.programData["years"].slice(-2) : null;
    var costs = props.programData["costs"] ? props.programData["costs"].slice(-2) : null;
    if (years) {
        firstYear = years[0];
        secondYear = years[1];
        firstCost = costs[0];
        secondCost = costs[1];
    }
    return (react_1.default.createElement("div", { className: styles.paddingTopContent },
        react_1.default.createElement("h3", { className: styles.textCenter },
            react_1.default.createElement("b", null,
                react_1.default.createElement("u", null, "Cost of Educational Program"))),
        react_1.default.createElement("p", { className: styles.paddingTopContent },
            "Total charges for the program for students completing on-time in ",
            firstYear,
            ": ",
            react_1.default.createElement("span", { className: styles.colorRed }, firstCost),
            ".",
            react_1.default.createElement("br", null),
            "Additional charges may be incurred if the program is not completed on-time."),
        react_1.default.createElement("p", null,
            "Total charges for the program for students completing on-time in ",
            secondYear,
            ": ",
            react_1.default.createElement("span", { className: styles.colorRed }, secondCost),
            ".",
            react_1.default.createElement("br", null),
            "Additional charges may be incurred if the program is not completed on-time.")));
}
exports.AsherCostProgram = AsherCostProgram;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXNoZXJDb3N0UHJvZ3JhbS5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9TY2hvb2xQZXJmb3JtYW5jZS9wYXJ0cy9Db3N0UHJvZ3JhbS9Bc2hlckNvc3RQcm9ncmFtLmNvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQXlCO0FBQ3pCLDJFQUE4RDtBQUU5RCxTQUFnQixnQkFBZ0IsQ0FBQyxLQUFLO0lBQ2xDLElBQUksU0FBUyxHQUFHLElBQUksQ0FBQTtJQUNwQixJQUFJLFVBQVUsR0FBRyxJQUFJLENBQUE7SUFDckIsSUFBSSxTQUFTLEdBQUcsRUFBRSxDQUFBO0lBQ2xCLElBQUksVUFBVSxHQUFHLEVBQUUsQ0FBQTtJQUNuQixJQUFNLEtBQUssR0FBRyxLQUFLLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUE7SUFDdEYsSUFBTSxLQUFLLEdBQUcsS0FBSyxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFBO0lBRXRGLElBQUksS0FBSyxFQUFFO1FBQ1AsU0FBUyxHQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUNwQixVQUFVLEdBQUcsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFBO1FBQ3JCLFNBQVMsR0FBRyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDcEIsVUFBVSxHQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQTtLQUN4QjtJQUVELE9BQU8sQ0FDSCx1Q0FBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLGlCQUFpQjtRQUNwQyxzQ0FBSSxTQUFTLEVBQUUsTUFBTSxDQUFDLFVBQVU7WUFDNUI7Z0JBQ0ksdUVBQWtDLENBQ2xDLENBQ0g7UUFDTCxxQ0FBRyxTQUFTLEVBQUUsTUFBTSxDQUFDLGlCQUFpQjs7WUFDZ0MsU0FBUzs7WUFBRyx3Q0FBTSxTQUFTLEVBQUUsTUFBTSxDQUFDLFFBQVEsSUFBRyxTQUFTLENBQVE7O1lBQUMseUNBQU07MEZBRXpJO1FBQ0o7O1lBQ3NFLFVBQVU7O1lBQUcsd0NBQU0sU0FBUyxFQUFFLE1BQU0sQ0FBQyxRQUFRLElBQUcsVUFBVSxDQUFROztZQUFDLHlDQUFNOzBGQUUzSSxDQUNGLENBQ1QsQ0FBQTtBQUNMLENBQUM7QUFoQ0QsNENBZ0NDIn0=